// extracted by mini-css-extract-plugin
export default {"SideBarContainer":"SideBar_SideBarContainer__KQP17","sidebarelement":"SideBar_sidebarelement__yCiUl"};